import React, { Component, Fragment } from 'react';

import { withStyles } from '@material-ui/core/styles';

import Modal from '@material-ui/core/Modal';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import red from '@material-ui/core/colors/red';
import Chip from '@material-ui/core/Chip';

import { Button, Form, FormCheckbox, InputText, VSpacer, FormControl } from 'sm-react-components';

import * as requests from '../../infrastructure/requests';

const styles = (theme) => ({
    card: {
        position: 'absolute',
        width: '300px',
        textAlign: 'center',
        top: `50%`,
        left: `50%`,
        transform: `translate(-50%, -50%)`,
    },
    tagsTitle: {
        ...theme.typography.h1,
    },
    center: {
        margin: 'auto'
    },
    content: { padding: '25px' },
    smallText: { fontSize: '11px', textAlign: 'left' },
    error: {
        backgroundColor: red[100],
        padding: '10px',
        marginTop: '5px',
        borderRadius: '5px'
    },
    chip: {
        margin: '1px'
    }
});

class ModalKey extends Component {
    constructor() {
        super();
        this.state = {
            name: '',
            tags: [],
            tag: '',
            error: undefined,
            loading: false,
            testMode: false,
            ready: false
        };
    }

    componentWillReceiveProps() {
        this.setState({
            name: '',
            tags: [],
            tag: '',
            error: undefined,
            loading: false,
            testMode: false,
            ready: false
        });
    }

    handleChange = name => value => {
        this.setState({
            [name]: value,
        });
    };

    addTag = () => {
        const { tag, tags } = this.state;
        if (tag.length === 0) return;
        if (tags.indexOf(tag) === -1) {
            this.setState({
                tags: [...tags, tag],
                tag: ''
            });
        }
        else {
            this.setState({
                tag: '',
            });
        }
    }

    deleteTag = (index) => {
        const tags = this.state.tags;
        tags.splice(index, 1);
        this.setState({ tags });
    }

    handleKeyPress = (event) => {
        event.stopPropagation();
        if (event.key === 'Enter') {
            event.preventDefault();
            this.addTag();
        }
    }

    handleClose = (id) => {
        const { onClose } = this.props;
        if (onClose) onClose(id);
    }

    handleSubmit = async () => {
        const { name, tags, testMode } = this.state;
        try {
            this.setState({ loading: true });
            const key = await requests.createKey(name, tags, testMode);
            this.handleClose(key.id);
        }
        catch (error) {
            this.setState({ error: error.message, loading: false });
        }
    }

    render() {
        const { name, testMode, tag, tags } = this.state;
        const { classes, open } = this.props;
        return (
            <Modal open={open} onClose={() => this.handleClose()}>
                <Card className={classes.card}>
                    <CardContent className={classes.content}>
                        <Typography color="textSecondary" variant="h5">
                            Create a new key
                        </Typography>
                        <VSpacer />
                        <Form direction='column' onSubmit={this.handleSubmit} lazyValidation>
                            <InputText
                                id="name"
                                label="Name"
                                margin="none"
                                value={name}
                                onChange={this.handleChange('name')}
                                validators={['required']}
                            />
                            <InputText
                                id="tag"
                                label="Tags"
                                margin="none"
                                value={tag}
                                onChange={this.handleChange('tag')}
                                onKeyPress={this.handleKeyPress}
                                helperText="Press Enter to add to the list"
                                onBlur={this.addTag}
                            />
                            <div>
                                {tags.map((tag, index) =>
                                    <Chip
                                        key={index}
                                        label={tag}
                                        onDelete={() => this.deleteTag(index)}
                                        className={classes.chip}
                                    />
                                )}
                            </div>
                            <VSpacer />
                            <FormCheckbox
                                checked={testMode}
                                onChange={(val) => this.setState({ testMode: val })}
                                labelComponent={<Typography style={{ textAlign: 'left' }}>Test mode</Typography>} />
                            <Fragment>
                                {testMode &&
                                    <div>
                                        <Typography className={classes.smallText}>
                                            Test mode is intended for <b>development</b> only:
                                        </Typography>
                                        <Typography className={classes.smallText}>
                                            - Requests won't count for the quota
                                        </Typography>
                                        <Typography className={classes.smallText}>
                                            - Requests will return fake responses
                                        </Typography>
                                        <VSpacer small />
                                        <Typography className={classes.smallText}>
                                            This mode can disabled anytime.
                                        </Typography>
                                    </div>
                                }
                            </Fragment>
                            <VSpacer />
                            <FormControl justify='center'>
                                <Button type='submit'>Create Key</Button>
                            </FormControl>
                        </Form>

                    </CardContent>
                </Card>
            </Modal >
        );
    }
}

export default withStyles(styles)(ModalKey);